import type { FC } from 'react';

import { useTranslation } from 'react-i18next';
import type { Provider } from '@vgtv/api-client';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { ProviderAccessMap } from '@vgtv/svp-access/lib/access_mappings';

import { config } from '../../config';
import {
  getAssetAccessLevel,
  isEntertainment,
} from '../../shared/helpers/assetHelpers';
import { Paywall } from '../Paywall/Paywall';
import { SimpleSubscribeButton } from '../SimpleSubscribeButton/SimpleSubscribeButton';
import { isHermesApp } from '../../utils/device';
import type { ButtonProps } from '../Button/Button';

import { getSubscriptionPrice } from './getSubscriptionPrice';

interface SubscribeButtonProps {
  asset: SvpAssetAdditional;
  label?: string;
  size?: ButtonProps['size'];
  access?: ProviderAccessMap[Provider];
}

const SubscribeButton: FC<SubscribeButtonProps> = ({
  asset,
  label: labelProp,
  access: accessProp,
  size = 'large',
}) => {
  const { t } = useTranslation();

  if (isHermesApp) {
    return null;
  }

  const access = accessProp || getAssetAccessLevel(asset);
  let price = getSubscriptionPrice();

  let label = labelProp;

  if (!label) {
    if (config.provider === 'vgtv') {
      label = t(
        access === 'sport' ? 'Subscribe to sport' : 'Subscribe to watch'
      );
    } else {
      if (isEntertainment(asset)) {
        label = 'Prova Plus för 19 kr';
        price = 19;
      } else {
        label = `Skaffa Plus 2 mån ${price}kr`;
      }
    }
  }

  const fallback = (
    <SimpleSubscribeButton
      asset={asset}
      label={label}
      price={access === 'plus' ? price : undefined}
      access={access}
      size={size}
    />
  );

  if (config.provider === 'ab') {
    return fallback;
  }

  return (
    <Paywall
      asset={asset}
      buttonLabel={label}
      buttonSize={size}
      fallback={fallback}
      access={access}
    />
  );
};

export { SubscribeButton };
